<template>
  <nav>
    <ul class="main">
      <router-link to="/works.html" tag="li">
        <a>WORKS</a>
        <ul class="sub">
          <router-link to="/works.html#graphic" tag="li"><a>graphic</a></router-link>
          <router-link to="/works.html#editorial" tag="li"><a>editorial</a></router-link>
          <router-link to="/works.html#package" tag="li"><a>package</a></router-link>
          <router-link to="/works.html#logo_ci_vi" tag="li"><a>logo,ci,vi</a></router-link>
          <router-link to="/works.html#character" tag="li"><a>character</a></router-link>
          <router-link to="/works.html#web" tag="li"><a>web</a></router-link>
        </ul>
      </router-link>
      <router-link to="/company.html" tag="li"><a>COMPANY</a></router-link>
      <router-link to="/yorozu/index.html" tag="li" v-bind:class="{ 'current' : $route.name.indexOf('yorozu')!=-1 }"><a>YOROZU</a></router-link>
      <router-link to="/access.html" tag="li"><a>ACCESS</a></router-link>
    </ul>
  </nav>
</template>

<script>
export default {
  watch: {
    '$route' (to, from) {
      if (to.name == 'works') {
        // WORKS内でグロナビのカテゴリを押した場合ページ内スクロール
        if (from.name == 'works' && to.hash) {
          this.$scrollTo(to.hash)
        }
      }
    }
  }
}
</script>

<style lang="scss">
nav {
  font-family: clarendon-text-pro, serif;
  font-weight: bold;
  transform-origin: 0;
  transform: scaleX(1.25);
  .main {
    display: flex;
    > li {
      margin: 0 10px;
      &:hover {
        .sub {
          li {
            height: 2em;
            &:first-child {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
  .sub {
    position: absolute;
    overflow: hidden;
    li {
      position: relative;
      height: 0;
      padding-left: 1em;
      transition: all .5s ease;
      &::before,
      &::after {
        content: '';
        position: absolute;
        transform: scaleX(.8);
      }
      &::before {
        bottom: 55%;
        left: 3px;
        width: 1px;
        height: 2em;
        background-color: #5a5858;
      }
      &::after {
        top: .6em;
        left: 0;
        width: 7px;
        height: 7px;
        background-color: #5a5858;
        border-radius: 50%;
      }
    }
    a {
      padding: 0 5px;
      background-color: rgba(245, 245, 245, .8);
    }
  }
  a {
    display: inline-block;
    color: #757575;
    text-decoration: none;
    &:hover {
      color: initial;
    }
  }
  .current {
    > a {
      color: red!important;
    }
  }
  @include mq {
    position: fixed;
    top: 0;
    right: 0;
    display: block;
    height: 100vh;
    padding: 60px 50px 30px 10px;
    background-color: black;
    transform: translateX(100%) scaleX(1.25);
    transition: transform .5s ease;
    .main {
      flex-direction: column;
      > li {
        > a {
          margin-top: 10px;
        }
        &:hover {
          .sub {
            li {
              &:first-child {
                margin-top: 5px;
              }
            }
          }
        }
      }
    }
    .sub {
      position: unset;
      li {
        height: auto!important;
        margin: 5px 0;
        transition: none;
      }
      a {
        padding: 0;
        background-color: transparent;
        color: #ccc;
      }
    }
    a {
      color: white;
      &:hover {
        color: inherit;
      }
    }
    &.open {
      transform: translateX(0) scaleX(1.25);
    }
  }
}
</style>
